import React from 'react';
import { COMING_SOON, ENTERPRISE_DRM } from '~/utils/constants';

interface ComingSoonProps {
  style: string;
  override?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ style, override }) => {
  const defaultClass = 'coming-soon-label';
  let stateClass = override ? `${defaultClass}--${override}` : '';

  if (style === COMING_SOON) {
    return (
      <span className={`${defaultClass} ${stateClass}`}>{COMING_SOON}</span>
    );
  }

  if (style === ENTERPRISE_DRM) {
    return (
      <span className={`${defaultClass} ${stateClass}`}>{ENTERPRISE_DRM}</span>
    );
  }

  return null;
}

export default ComingSoon;